import { Component, Input, OnDestroy, OnInit } from "@angular/core";
import { FormControlName, UntypedFormGroup } from "@angular/forms";
import { UtilService } from "../../services/util.service";
import { EnumService } from "../../services/enum.service";
import { SharedDataService } from "../../services/shared-data.service";
import { FormService } from "../../services/form.service";
import { Subscription } from "rxjs";
import { ActivityService } from "../../services/activity.service";

@Component({
  selector: "app-custom-questions-container",
  templateUrl: "./custom-questions-container.component.html",
  styleUrls: ["./custom-questions-container.component.scss"],
})
export class CustomQuestionsContainerComponent implements OnInit, OnDestroy {
  UtilService = UtilService;
  EnumService = EnumService;

  @Input() sectionIndex: number;
  @Input() sectionId: number;
  @Input() formGroup: UntypedFormGroup;
  @Input() questions: Array<any>;
  @Input() questionElementIds: Array<string>;
  @Input() isSubmitted: boolean;
  @Input() isShowAnswerScoreEnabled: boolean;
  @Input() section: any;
  @Input() userList: any;
  @Input() signatureId: any;
  @Input() answers: any;
  @Input() permissionsToRelaunch: any;
  @Input() permissionsToSpecificQuestions: any;
  

  private selectedChoiceSubscription: Subscription;
  selectedChoice: any;

  private checkboxStatesSubscription: Subscription;
  checkboxStates: any[] = []; // Initialize as required

  private confirmBoxSubscription: Subscription;
  isConfirmBox: any;

  isAction: boolean = false;
  showActivityPopup = false;
  activityPopupData: any = null;

  constructor(
    public sharedDataService: SharedDataService,
    public utilService: UtilService,
    private formService: FormService,
    private activityService: ActivityService
  ) { }

  ngOnInit() {
    this.selectedChoiceSubscription = this.sharedDataService.selectedChoice$.subscribe(
      (value) => {
        this.selectedChoice = value;

        if (this.questions && this.questions.length > 0) {
          this.questions.forEach((question) => {
            if (question && question.answerChoiceAttributes && question.answerChoiceAttributes.length > 0) {
              const answerAttributes = question.answerChoiceAttributes;
              const selectedIndex = answerAttributes.findIndex((attribute) => {
                return attribute.answerChoiceAttributeId === this.selectedChoice;
              });

              if (selectedIndex !== -1) {
                const answer = answerAttributes[selectedIndex];
            
                // Check if this answer was already selected
                const wasAlreadySelected = answer.isSelected === true;
                const questionLogics = question.questionLogics;
                if (questionLogics) {
                  let shouldShowAction = false; // Flag to determine if the action box should be shown for this specific question

                  questionLogics.forEach((logic) => {
                    if (logic.questionActionTypeID === 21) {
                      if (
                        logic.questionChoiceSetTypeID === 1 &&
                        selectedIndex + 1 === logic.questionChoiceSetSequence
                      ) {
                        shouldShowAction = true;
                      } else if (
                        logic.questionChoiceSetTypeID === 2 &&
                        selectedIndex + 1 !== logic.questionChoiceSetSequence
                      ) {
                        shouldShowAction = true;
                      }
                    }
                  });

                  // Update the question's shouldShowOptionalAction independently
                  question.shouldShowOptionalAction = shouldShowAction;
                }
                this.onAnswerUpdated({
                  "answerChoiceAttributeId": this.selectedChoice,
                  "questionId": question.questionId
              }, this.sharedDataService.isUserClickingSingleChoice)
              }
            }
          });
        } else {
          console.log('No valid questions array.');
        }
      }
    );

    this.checkboxStatesSubscription = this.sharedDataService.checkboxStates$.subscribe(
      (states) => {
        this.checkboxStates = states;

        this.checkboxStates.forEach((checkboxState) => {
          const targetQuestionId = checkboxState.questionId;

          // Find the question with the targetQuestionId
          const targetQuestion = this.questions.find((question) => question.questionId === targetQuestionId);

          if (targetQuestion && targetQuestion.selectedAnswerTypeId === 2) {
            const choices = [];
            targetQuestion.answerChoiceAttributes.forEach((attr) => {
              choices.push({
                answerChoiceAttributeId: attr.answerChoiceAttributeId,
                isChecked: false // Default value
              });
            });

            // Update isChecked based on checkboxStates
            choices.forEach((choice) => {
              const matchingState = this.checkboxStates.find((state) => state.answerChoiceAttributeId === choice.answerChoiceAttributeId && state.questionId === targetQuestionId);
              if (matchingState) {
                choice.isChecked = matchingState.isChecked;
              }
            });

            const checkedIndices = choices.reduce((indices, choice, index) => {
              if (choice.isChecked) {
                indices.push(index + 1);
              }
              return indices;
            }, []);

            targetQuestion.shouldShowOptionalAction = false; // Reset to false before re-evaluating

            targetQuestion.questionLogics.some((logic) => {
              if (logic.questionActionTypeID === 21) {
                if (logic.questionChoiceSetTypeID === 1) {
                  if (checkedIndices.includes(logic.questionChoiceSetSequence)) {
                    targetQuestion.shouldShowOptionalAction = true;
                    return true; // Exit loop if a match is found
                  }
                } else if (logic.questionChoiceSetTypeID === 2) {
                  if (!checkedIndices.includes(logic.questionChoiceSetSequence)) {
                    targetQuestion.shouldShowOptionalAction = true;
                    return true; // Exit loop if a match is found
                  }
                }
              }
              return false;
            });
          }
        });
      }
    );



    this.confirmBoxSubscription = this.sharedDataService.confirmBoxesState$.subscribe(
      (confirmBoxesState) => {
        if (this.questions && this.questions.length > 0) {
          this.questions.forEach((question) => {
            if (question.selectedAnswerTypeId === 14) {
              const confirmBoxState = confirmBoxesState.find((box) => box.confirmBoxId === question.questionId);
              if (confirmBoxState) {
                const logicWithActionType21 = question.questionLogics.find((logic) => logic.questionActionTypeID === 21);
                if (logicWithActionType21) {
                  question.shouldShowOptionalAction = confirmBoxState.isChecked;
                }
              }
            }
          });
        }
      }
    );


  }

  getQuestionAnswerByQuestionID(questionID: number, parentQuestionID: number) {
    if (!this.answers) {
      return null;
    }
    //console.log('this.answers',this.answers?.find(question => question.questionID === questionID))
    if(parentQuestionID !== 0){
      return this.answers?.find(question => question.parentQuestionID !== 0 ?question.parentQuestionID  === parentQuestionID: question.questionID  === parentQuestionID);
    }else{
      return this.answers?.find(question => question.parentQuestionID !== 0 ?question.parentQuestionID  === questionID: question.questionID  === questionID);
    }
      
  }

  getNonNullQuestionAnswerByQuestionID(questionID:number,parentQuestionID:number, type = ""){
    if (!this.answers) {
      return null;
    }
    try{
    let choices;
    if(parentQuestionID !== 0){
      choices = this.answers?.filter(question => question.parentQuestionID !== 0 ?question.parentQuestionID  === parentQuestionID: question.questionID  === parentQuestionID);
    }else{
      choices = this.answers?.filter(question => question.parentQuestionID !== 0 ?question.parentQuestionID  === questionID: question.questionID  === questionID);
    }
    //console.log('choices', choices, questionID)
      if (type !=""){
        switch(type){
          case "singleChoiceValueID":
            for(const choice of choices){if(choice.singleChoiceValueID !=null) {return choice}}
            break;
          case "multipleChoiceValueIDs":
            for(const choice of choices){if(choice.multipleChoiceValueIDs !=null){ return choice}}
              break;
          case "isConfirmBoxChecked":
            for(const choice of choices){if(choice.isConfirmBoxChecked !=null){ return choice}}
            break;
          case "matrixQAnswer":
            for(const choice of choices){if(choice.matrixQAnswer !=null){ return choice}}
            break;
          case "textValue":
            for(const choice of choices){if(choice.textValue !=null){ return choice}}
            break;
          case "integerValue":
            for(const choice of choices){if(choice.integerValue !=null){ return choice}}
              break;
          case "decimalValue":
            for(const choice of choices){if(choice.decimalValue !=null){ return choice}}
            break;
          case "dateValue":
            for(const choice of choices){if(choice.dateValue !=null){ return choice}}
            break;
          case "timeValue":
            for(const choice of choices){if(choice.timeValue !=null){ return choice}}
            break;
          case "dateTimeValue":
            for(const choice of choices){if(choice.dateTimeValue !=null){ return choice}}
            break;
          case "imageVideoDocFileDetails":
            for(const choice of choices){if(choice.imageVideoDocFileDetails !=null){ return choice}}
            break;
                    
          default:
            return choices[0]
        }
      } else{
        return choices[0]
      }
    }
    catch{
      return null
    }
  }

  getUniqueImageVideoDocFileDetails(questionID: number, parentQuestionID: number) {
    const details = this.getQuestionAnswerByQuestionID(questionID, parentQuestionID)?.imageVideoDocFileDetails;
    if (!details?.length) return details;
    const seen = new Set();
    return details.filter(item => {
      if (seen.has(item.fileLink)) return false;
      seen.add(item.fileLink);
      return true;
    });
  }

  getQuestionPermissionAnswerByQuestionID(questionID: number) {
    // if (!this.permissionsToRelaunch) {
    //  // console.log('!this.permissionsToRelaunch')
    //   return null;
    // }
    // else if (this.permissionsToSpecificQuestions) {
    //   console.log('specific question', questionID)
    //   console.log('this.permissionsToRelaunch[this.sectionIndex]?.questions?.find(question => question.questionId === questionID)',this.permissionsToRelaunch[this.sectionIndex]?.questions?.find(question => question.questionId === questionID))
    //   return this.permissionsToRelaunch[this.sectionIndex]?.questions?.find(question => question.questionId === questionID);
    // }
    // else {
    //  console.log('true true true', questionID, {isQuestionRelaunchable: true})
    //   return {isQuestionRelaunchable: true};
    // } 

    if (!this.sharedDataService.relaunchFormStateData?.formDetailViewModels?.formDetailData?.isRelaunchResponse) {
      return { isQuestionRelaunchable: false };
  } else {
      if (this.sharedDataService.relaunchFormStateData.formDetailViewModels?.formDetailData?.isRelaunchSpecificQuestion) {
          var questionToRelaunch = this.questions.find(q => q.questionId === questionID); 
          
          if (questionToRelaunch && questionToRelaunch.isQuestionRelaunchable) {
              return { isQuestionRelaunchable: true };
          } else {
              return { isQuestionRelaunchable: false }; 
          }
      } else {
          return { isQuestionRelaunchable: true };
      }
  }
  
   
  
   
  }

  ngOnDestroy() {
    // Don't forget to unsubscribe to avoid memory leaks
    this.selectedChoiceSubscription.unsubscribe();
    this.checkboxStatesSubscription.unsubscribe();
    this.confirmBoxSubscription.unsubscribe();
  }


  onAnswerUpdated(event: any, userTriggered = true) {
    this.formService.updateFormScore(event);
    // if (userTriggered) {
    console.log('userTriggered', userTriggered);

    if (userTriggered !== true) {
      console.log('Skipping activity - not user triggered');
      return;
    }

    if (this.activityService.isProgrammaticDeselect) {
      console.log('Skipping activity - programmatic deselect');
      return;
    }

    this.activityService.triggerActivity({
      questionId: event.questionId,
      answer: event,
      section: this.section,
      selectedAnswerIds: this.getSelectedAnswerIds(event),
    });
    // }
    //this.checkForNewActivity(event);
    //this.formService.checkChosenVisibleAnswers()
  }

  // Answers currently selected for a single/multiple choice question, read from the form
  // so the activity logic is evaluated on the question's whole state, not only the clicked answer.
  private getSelectedAnswerIds(event: any): number[] | undefined {
    const question = this.questions?.find((q) => q.questionId === event.questionId);
    if (!question) return undefined;

    const fcName = UtilService.FCUniqueName(this.section, question);
    const control = this.formGroup?.get(fcName);
    if (!control) return undefined;

    if (question.selectedAnswerTypeId === EnumService.CustomAnswerType.SingleChoiceSet) {
      return control.value != null && control.value !== '' ? [Number(control.value)] : [];
    }

    if (question.selectedAnswerTypeId === EnumService.CustomAnswerType.MultipleChoiceSet) {
      return question.answerChoiceAttributes
        .filter((attr) => {
          if (attr.answerChoiceAttributeId === event.answerChoiceAttributeId && event.isChecked !== undefined) {
            return event.isChecked;
          }
          return control.get(UtilService.SubFCName(fcName, attr.answerChoiceAttributeId))?.value === true;
        })
        .map((attr) => attr.answerChoiceAttributeId);
    }

    return undefined;
  }

  shouldShowError(question) {
    if (
      question.selectedAnswerTypeId ===
      EnumService.CustomAnswerType.SingleChoiceSet ||
      question.selectedAnswerTypeId ===
      EnumService.CustomAnswerType.MultipleChoiceSet ||
      question.selectedAnswerTypeId ===
      EnumService.CustomAnswerType.ConfirmationBox
    ) {
      return true;
    }
    return true;
    // return false;
  }

  isError(question, questionIndex) {
    const controlName = UtilService.FCUniqueName(this.section, question);
    return this.isSubmitted && !this.formGroup.controls[controlName].valid;
  }

  getAllowedQrCodeTypes = (question) => {
    const arr = [];
    if (question) {
      if (question.allowQRCodeLocation) {
        arr.push(EnumService.SelectedQRCodeType.Location);
      }
      if (question.allowQRCodeProject) {
        arr.push(EnumService.SelectedQRCodeType.Project);
      }
      if (question.allowQRCodeInventoryItem) {
        arr.push(EnumService.SelectedQRCodeType.InventoryItem);
      }
      if (question.allowQRCodeDocument) {
        arr.push(EnumService.SelectedQRCodeType.Document);
      }
      if (question.allowQRCodeForm) {
        arr.push(EnumService.SelectedQRCodeType.Form);
      }
      if (question.allowQRCodeUser) {
        arr.push(EnumService.SelectedQRCodeType.User);
      }
    }

    return arr;
  }

  logAnswerSelection() {
    const nameControl = this.formGroup.get('name');
    nameControl?.valueChanges.forEach(
      (value: string) => console.log(value)
    );
  }

  checkForNewActivity(event: any) {
    const answeredQuestion = this.questions.find(q => q.questionId === event.questionId);
    console.log('answeredQuestion', answeredQuestion);
    
    if (!answeredQuestion) {
        console.warn('Question not found with ID:', event.questionId);
        return;
    }

    console.log('Question details:', {
        isCreateNewActivity: answeredQuestion.isCreateNewActivity,
        selectedAnswerTypeId: answeredQuestion.selectedAnswerTypeId
    });

    if (answeredQuestion.isCreateNewActivity) {
        console.log('CREATE NEW ACTIVITY - Question-level trigger', event.answerChoiceAttributeId);
        this.showActivityPopup = true;
        return;
    }

    if (answeredQuestion.selectedAnswerTypeId === this.EnumService.CustomAnswerType.SingleChoiceSet) {
        const selectedChoice = answeredQuestion.answerChoiceAttributes.find(
            attr => attr.answerChoiceAttributeId === event.answerChoiceAttributeId
        );
        
        if (selectedChoice?.isCreateNewActivity) {
            console.log('CREATE NEW ACTIVITY - Single choice trigger');
        }
    } else if (answeredQuestion.selectedAnswerTypeId === this.EnumService.CustomAnswerType.MultipleChoiceSet) {
        const hasCreateNewActivity = answeredQuestion.answerChoiceAttributes.some(
            attr => event.multipleChoiceValueIDs?.includes(attr.answerChoiceAttributeId) && attr.isCreateNewActivity
        );
        
        if (hasCreateNewActivity) {
            console.log('CREATE NEW ACTIVITY - Multiple choice trigger');
        }
    }
  }
}
